/* eslint-disable jira/filename-case */
import { JS_EVAL_START } from '@jira/platform__common-constants/src/analytics-marks.js';
import { stopInitialPageLoadTimingFromPerformanceMarkStart } from '@atlassian/jira-spa-performance-breakdown/src/utils/performance-marks-tools/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type TopNavigation from './ui/TopNavigation.tsx';

export const LazyAtlassianNavigation: LazyComponent<typeof TopNavigation> = lazyForPaint<
	typeof import('./ui/TopNavigation.tsx').TopNavigation
>(
	() => {
		const bundleReady = import(
			/* webpackChunkName: "async-atlassian-navigation" */ './ui/TopNavigation.tsx'
		).then(({ TopNavigation }) => TopNavigation);

		if (!__SERVER__) {
			bundleReady.then(() => {
				stopInitialPageLoadTimingFromPerformanceMarkStart(
					'navigation-primary.bundle-ready',
					'jira-spa.js:eval-stop',
				);
				const resources = performance.getEntriesByType('mark');
				for (let i = resources.length - 1; i >= 0; i -= 1) {
					if (
						(resources[i].name.startsWith('async-navigation') ||
							resources[i].name.startsWith('async-atlassian-navigation')) &&
						resources[i].name.endsWith(JS_EVAL_START)
					) {
						stopInitialPageLoadTimingFromPerformanceMarkStart(
							'navigation-primary.eval',
							resources[i].name,
						);
						break;
					}
				}
			});
		}
		return bundleReady;
	},
	{
		entryFsSsrLiftImportToModule: true,
		includeInShellOnlySsrBundle: true,
	},
);
